import { NoteBlock } from "../block";

export interface CodeBlock extends NoteBlock {
  "code-block-id": string;
  type: "omega/query-omega/page/block/code-block/CodeBlockPageBlock";
}

export function isCodeBlockPageBlock(block: NoteBlock): block is CodeBlock {
  return (block as CodeBlock)["code-block-id"] !== undefined;
}
